import { getParticipantNip } from '../lib/participant-nip';
import { useAuthStore } from '../store/auth';
import { useRegistrations } from './useRegistrations';

/**
 * Resolves the global NIP for any authenticated participant screen.
 * Registration data is only a temporary fallback for an older browser session
 * that has not yet received its refreshed account payload after registration.
 */
export function useParticipantNip(): string | null {
  const user = useAuthStore(state => state.user);
  const { data: registrationsResponse } = useRegistrations(user?.id);

  return getParticipantNip(user, registrationsResponse?.items ?? []);
}
